import React, { useState } from 'react';

function IndicatorDown(props) {
  const { handleClick, extraClasses, size = "small", wrapperElement = "div" } = props || {};
  const [WrapperComponent] = useState(wrapperElement);

  return (
    <WrapperComponent
      role="img"
      onClick={handleClick}
      className={`mls-o-svg transform ${extraClasses ? extraClasses : ""}`}>
      <span className={`oc-o-icon--indicator-down icon-svg fa-icon-svg fa-icon-svg--${size}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="#d84142">
          <polygon points="10 13 13.39 16.39 15 18 20 13 10 13" />
        </svg>
      </span>
    </WrapperComponent>
  );
}

// eslint-disable-next-line no-const-assign,no-func-assign
IndicatorDown = React.memo(IndicatorDown);

export default IndicatorDown;
